export const DAO_CODE = 'LOCATION' + '_DAO';
